import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import { AssessmentContext } from "../../contexts/assessments";
import { Typography } from "@mui/material";
import BlocksAdmin from "../../components/BlocksAdmin";
import UsersAssessment from "../../components/UsersAssessment";
import CompaniesTIM from "../../components/CompaniesTIM";
import Companies360 from "../../components/Companies360";
import { getCompaniesByCategory } from "../../axios/axiosFunctions";

const slugToCategoryMap = {
    tim_self_assessment: "tim",
    lim_360_assessment: "lim360",
    mim_360_assessment: "mim360",
};

const AssessmentAdmin = () => {

    const {slugAssessment} = useParams();
    const {isLoading,getAssessmentBySlug} = useContext(AssessmentContext)
    const [rows, setRows] = useState([{id:1}]);
    const [currentAssessment, setCurrentAssessment] = useState();
    const [allCompanies, setAllCompanies] = useState([]);
    const [loadingCompanies, setLoadingCompanies] = useState(true);

    const category = slugToCategoryMap[slugAssessment];

    useEffect(() => {
        if(!isLoading){
            if(category){
                callCompanies();
            }
            const assessment = getAssessmentBySlug(slugAssessment);
            setCurrentAssessment(assessment);
        }
    }, [isLoading,slugAssessment]);

    useEffect(() => {
        if(currentAssessment){
            const tempRows = currentAssessment?.users.map((u)=>({
                id: u._id,
                firstName: u.firstName,
                lastName: u.lastName,
                email: u.email,
            }));
            setRows(tempRows);
        }
    }, [currentAssessment]);

    const callCompanies = async()=>{
        const companies = await getCompaniesByCategory(category);
        setAllCompanies(companies);
        setLoadingCompanies(false);
    }

    return (
    <>
        <Typography component={"div"} variant="h3" fontWeight={500} color="secondary" dangerouslySetInnerHTML={{ __html: currentAssessment?.name }}/>
        {
            (slugAssessment === "mim_self_assessment" || slugAssessment === "lim_self_assessment") &&
            <>
                <BlocksAdmin blocks={currentAssessment?.blocks}/>
                <UsersAssessment rows={rows} assessmentId={currentAssessment?._id}/>
            </>
        }
        {
            slugAssessment === "tim_self_assessment" && <CompaniesTIM companies={allCompanies} callCompanies={callCompanies} loading={loadingCompanies} category={"tim"}/>
        }
        {
            slugAssessment === "lim_360_assessment" && <Companies360 companies={allCompanies} callCompanies={callCompanies} loading={loadingCompanies} category={"lim360"}/>
        }
        {
            slugAssessment === "mim_360_assessment" && <Companies360 companies={allCompanies} callCompanies={callCompanies} loading={loadingCompanies} category={"mim360"}/>
        }
    </>
    )
}

export default AssessmentAdmin